import { Link } from "react-router-dom";
import "../css/GamesUniform.css";

const SoccerGames = () => {
    return (
        <main id="games-content">
            <h2 id="quest">What Soccer Game Would You Like To Play?</h2>

            <section id="games-section">
                <Link to="/soccer-guess-player" className="game-link">
                    <div className="game-card">
                        <h3>Guess the Soccer Player</h3>
                        <p>Identify the player from clues and stats.</p>
                    </div>
                </Link>

                <Link to="/soccer-memory-game" className="game-link">
                    <div className="game-card">
                        <h3>Memory Game</h3>
                        <p>Match the soccer club logo pairs on the board.</p>
                    </div>
                </Link>

                <Link to="/trivia" className="game-link">
                    <div className="game-card">
                        <h3>Trivia</h3>
                        <p>Test your soccer knowledge with quick questions.</p>
                    </div>
                </Link>
            </section>
        </main>
    );
};

export default SoccerGames;